import React from "react";
import Button from "@mui/material/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PTMTooltip from "./PTMToolTip";

export default function PTMButton(props) {
    const {
        popover,
        disabledPopover,
        sx,
        variant,
        onMouseDown,
        onClick,
        popoverSx,
        style,
        children,
        disabled,
        color,
        component,
        size,
        className,
        buttonRef,
        icon,
        fullWidth,
        tooltipSx,
    } = props;

    return (
        popover && !disabled ? (
            <PTMTooltip title={popover} style={{ lineHeight: "initial", ...popoverSx }} tooltipSx={tooltipSx}>
                <Button
                    sx={sx}
                    variant={variant}
                    onMouseDown={onMouseDown}
                    onClick={onClick}
                    color={color}
                    disabled={disabled}
                    style={style}
                    component={component}
                    size={size}
                    className={className}
                    ref={buttonRef}
                    fullWidth={fullWidth}
                >
                    {icon && <FontAwesomeIcon icon={icon} />}
                    {children}
                </Button>

            </PTMTooltip>
        ) : (
            disabledPopover && disabled ? (
                <PTMTooltip title={disabledPopover} style={{ lineHeight: "initial", ...popoverSx }}>
                    <Button
                        sx={sx}
                        variant={variant}
                        onMouseDown={onMouseDown}
                        onClick={onClick}
                        color={color}
                        disabled={disabled}
                        style={style}
                        component={component}
                        size={size}
                        className={className}
                        ref={buttonRef}
                        fullWidth={fullWidth}
                    >
                        {icon && <FontAwesomeIcon icon={icon} />}
                        {children}
                    </Button>
                </PTMTooltip>
            ) : (
                <Button
                    sx={sx}
                    variant={variant}
                    onMouseDown={onMouseDown}
                    onClick={onClick}
                    color={color}
                    disabled={disabled}
                    style={style}
                    component={component}
                    size={size}
                    className={className}
                    ref={buttonRef}
                    fullWidth={fullWidth}
                >
                    {icon && <FontAwesomeIcon icon={icon} />}
                    {children}
                </Button>
            )
        )
    );
}
